var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.188 9a2.813 2.813 0 1 1 5.625 0 2.813 2.813 0 0 1-5.626 0ZM9 7.312a1.688 1.688 0 1 0 0 3.376 1.688 1.688 0 0 0 0-3.376Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.243 7.985c-.315.453-.43.807-.43 1.015 0 .208.115.562.43 1.015.303.438.755.913 1.326 1.351 1.146.88 2.716 1.572 4.431 1.572 1.715 0 3.285-.693 4.43-1.572.572-.438 1.024-.913 1.327-1.35.315-.454.43-.808.43-1.016 0-.208-.115-.562-.43-1.015-.303-.438-.755-.913-1.326-1.351-1.146-.88-2.716-1.572-4.431-1.572-1.715 0-3.285.693-4.43 1.572-.572.438-1.024.913-1.327 1.35Zm.642-2.244C5.182 4.745 6.987 3.938 9 3.938c2.013 0 3.818.807 5.115 1.803.65.5 1.187 1.056 1.567 1.602.368.532.63 1.115.63 1.657s-.262 1.125-.63 1.657c-.38.546-.917 1.103-1.567 1.602-1.297.996-3.102 1.803-5.115 1.803-2.013 0-3.818-.807-5.115-1.803-.65-.5-1.187-1.056-1.567-1.602-.368-.532-.63-1.115-.63-1.657s.262-1.125.63-1.657c.38-.546.916-1.103 1.567-1.602Z",
    fill: "#123862"
  })));
};
export default SvgEye;